import { useSelector } from 'react-redux'
import { RootStoreModel } from './store.model'

export const useLeadSearchMode = () => {
  return useSelector((state: RootStoreModel) => state.leadsState.searchMode)
}

export const useLeadsSearchFilters = () => {
  return useSelector((state: RootStoreModel) => state.leadsState.leadsSearchFilters)
}

export const useLeadsDataTable = () => {
  return useSelector((state: RootStoreModel) => state.leadsState.leadsDataTable)
}
